export default "__VITE_PUBLIC_ASSET__4cc077b8__"